class TermoDeUsoController extends AbstractController
  @$inject = ['$injector', '$scope', 'pathService', 'termoDeUsoService', 'perfilService']

  constructor: ($injector, scope, pathService, @termoDeUsoService, @perfilService) ->
    super($injector)

    @url = "#{pathService.getViewUrl()}eficiencia-fiscal/view/configuracao/termo-de-uso/"
    @modalTermoDeUso = @openPopup("#{@url}modal.html", 'termoDeUsoModalController as ctrl', 'lg', 'static')

    @loadingTracker = @promiseTracker()

    @filtro =
      perfil: ''
      vigenciaInicio: ''
      vigenciaFim: ''
    @listOfPerfil = []
    @listOfTermoDeUso = []

    @loadFiltro()
    @loadData()

  loadFiltro: ->
    @loadingTracker.addPromise @perfilService.getList((data) =>
      @listOfPerfil = data
    )

  loadData: ->
    @loadingTracker.addPromise @termoDeUsoService.getList(@filtro, (data) =>
      @listOfTermoDeUso = data
    )

  adicionar: ->
    @modalTermoDeUso({
        listOfPerfil: => @listOfPerfil
        termoDeUso: => {}
      }, (result) =>
      if result.success
        @listOfTermoDeUso.push(result.data)
    )

  editar: (termoDeUso) ->
    @modalTermoDeUso({
        listOfPerfil: => angular.copy @listOfPerfil
        termoDeUso: => angular.copy termoDeUso
      }, (result) =>
      if result.success
        index = @listOfTermoDeUso.getIndex(termoDeUso.id, 'id')
        @listOfTermoDeUso[index] = result.data
    )

  remover: (termoDeUso)->
    Confirm.warning('Atenção', "Deseja realmente remover o termo de uso ##{termoDeUso.id} do perfil #{termoDeUso.perfil.display_name}?", {
      'Sim': =>
        @termoDeUsoService.delete(termoDeUso.id, (result)=>
          if(result.success)
            Alert.success("O termo de uso ##{termoDeUso.id} do perfil #{termoDeUso.perfil.display_name} foi removido.", 'Sucesso!')
            @listOfTermoDeUso.remove @listOfTermoDeUso.getIndex(termoDeUso.id, 'id')
          else
            Alert.error("Ocorreu um erro ao remover o termo de uso ##{termoDeUso.id}.", "Erro!")
        )
      'Não': =>
    })

class TermoDeUsoModalController extends AbstractController
  @$inject = ['$injector', '$filter', '$uibModalInstance', 'termoDeUsoService', 'listOfPerfil', 'termoDeUso']

  constructor: ($injector, @filter, @modalInstance, @termoDeUsoService, @listOfPerfil, @termoDeUso) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @termoDeUso.perfil = @termoDeUso?.perfil?.id

  salvar: (form) ->
    if form.$valid
      @submitTracker.addPromise @termoDeUsoService.save(@termoDeUso, (result) =>
        if result.success
          Alert.success("Termo de uso ##{result.data.id} #{if @termoDeUso.id then 'atualizado' else 'criado'} para o perfil <strong>#{result.data.perfil.display_name}</strong>.", "Sucesso!")
        else
          Alert.error("Ocorreu um erro ao salvar o termo de uso!", "Erro")

        @modalInstance.close(result)
      )

class TermoDeUsoAceiteModalController extends AbstractController
  @$inject = ['$injector', '$filter', '$uibModalInstance', 'aceiteTermoDeUsoService', 'contrato', 'entidade', 'termoDeUso']

  constructor: ($injector, @filter, @modalInstance, @aceiteTermoDeUsoService, @contrato, @entidade, @termoDeUso) ->
    super($injector)
    @submitTracker = @promiseTracker()

  aceitarTermo: ->
    @submitTracker.addPromise @aceiteTermoDeUsoService.aceitarTermo({
      contrato: @contrato.id
      entidade: @entidade.id
      termoDeUso: @termoDeUso.id
    }, (result) => @modalInstance.close(result))

angular.module("eficienciaFiscalModule").controller('termoDeUsoController', TermoDeUsoController)
angular.module("eficienciaFiscalModule").controller('termoDeUsoModalController', TermoDeUsoModalController)
angular.module("eficienciaFiscalModule").controller('termoDeUsoAceiteModalController', TermoDeUsoAceiteModalController)